import React from 'react';
import mastercard from '../../../assets/payment/mastercard.png';
import bitpay from '../../../assets/payment/bitpay.png';
import visa from '../../../assets/payment/visa.png';
import americanexpress from '../../../assets/payment/americanexpress.png';
import discover from '../../../assets/payment/discover.png';
import sofort from '../../../assets/payment/sofort.png';
import gpay from '../../../assets/payment/gpay.png';
import applepay from '../../../assets/payment/applepay.png';
import paypal from '../../../assets/payment/paypal.png';
import maestro from '../../../assets/payment/maestro.png';
import insta from '../../../assets/logos/instaFLogo.svg';
import fb from '../../../assets/logos/fbFLogo.svg';
import x from '../../../assets/logos/xFLogo.svg';
import pinterest from '../../../assets/logos/pinFLogo.svg';
import { FaInstagram, FaMailBulk, FaWhatsapp } from 'react-icons/fa';
import { GrMail } from 'react-icons/gr';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <section className='w-full bg-slate-800'>
      <footer className='flex flex-col md:items-start lg:items-center self-stretch px-20 pt-20 pb-5 lg:pb-5 max-md:px-5 max-md:max-w-full'>
        <div className='flex flex-col w-full max-w-[1381px] max-md:max-w-full'>
          <div className='flex flex-wrap gap-5 justify-between w-full max-md:max-w-full'>
            <div className='flex gap-10 self-start text-base'>
              <div className='flex flex-col self-start'>
                <h3 className='self-start font-bold text-white text-opacity-80'>
                  Company
                </h3>
                <nav className='mt-2 leading-8 text-white text-opacity-60'>
                  <ul>
                    <li>
                      <Link to='/about' className='font-normal'>
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link to='/contact' className='font-normal'>
                        Contact us
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className='flex flex-col'>
                <h3 className='self-start font-bold text-white text-opacity-80'>
                  Help
                </h3>
                <nav className='mt-2 leading-8 text-white text-opacity-60'>
                  <ul>
                    <li>
                      <Link to='/terms' className='font-normal'>
                        Terms and conditions
                      </Link>
                    </li>
                    <li>
                      <Link to='/privacy' className='font-normal'>
                        Privacy policy
                      </Link>
                    </li>
                    <li>
                      <Link to='/refund' className='font-normal'>
                        Refund policy
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className='flex flex-col items-start'>
              <h3 className='text-base font-bold text-white text-opacity-80'>
                Payment methods possible
              </h3>
              <div className='flex gap-1.5 self-stretch mt-5'>
                <img
                  loading='lazy'
                  src={mastercard}
                  alt='Payment method 1'
                  className='object-contain shrink-0 w-10 rounded-xl aspect-[1.54]'
                />
                <img
                  loading='lazy'
                  src={visa}
                  alt='Payment method 3'
                  className='object-contain shrink-0 w-10 rounded-xl aspect-[1.54]'
                />
                <img
                  loading='lazy'
                  src={americanexpress}
                  alt='Payment method 4'
                  className='object-contain shrink-0 w-10 rounded-xl aspect-[1.54]'
                />
                <img
                  loading='lazy'
                  src={gpay}
                  alt='Payment method 7'
                  className='object-contain shrink-0 w-10 rounded-xl aspect-[1.54]'
                />
              </div>
              <h3 className='mt-7 text-base font-bold text-white text-opacity-80'>
                <a href='/'>Thoorigai</a>
              </h3>
            </div>
          </div>
          <div className='flex flex-wrap gap-5 justify-between items-center self-end lg:mt-24 max-w-full text-base text-white text-opacity-60 w-full max-md:mt-8 max-md:mr-2.5'>
            <p className='self-end mt-6 font-light'>
              Copyright 2025. Thoorigai-All Rights Reserved
            </p>
            <div className='flex items-start mt-0 md:mt-6 gap-3 mr-14'>
              <a
                target='_blank'
                className='bg-[#7AB2D3] p-2 rounded-full'
                href='mailto:enquiries.thoorigai@gmail.com'
              >
                <GrMail size={30} color='#fff' />
              </a>
              <a
                target='_blank'
                className='bg-[#7AB2D3] p-2 rounded-full'
                href='https://www.instagram.com/thoorigai.net_?igsh=MTQzYWI5bGZuNnZ4YQ=='
              >
                <FaInstagram size={30} color='#fff' />
              </a>
              <a
                target='_blank'
                className='bg-[#7AB2D3] p-2 rounded-full'
                href='https://wa.me/918825532600'
              >
                <FaWhatsapp size={30} color='#fff' />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
}

export default Footer;
